export default __webpack_public_path__ + "static/media/art_bg.47e45cea.png";